import { Token } from "inversify-token";
import { CardsDataSource } from "./CardsDataSource";

export const CardsDataSourceToken = new Token<CardsDataSource>(Symbol.for("CardsDataSource"));
